import { connect } from 'react-redux'
import { IStore } from '../../../reducers'
import { getReservationLabelPattern } from '../../../reducers/userObject/selectors/settings'
import { IDateInputProps } from './DateInput'

function mapStateToProps() {
  const patterns = getReservationLabelPattern

  return (state: IStore): Pick<IDateInputProps, 'formatDate'> => ({
    formatDate: patterns(state).formatDate,
  })
}

export default connect(mapStateToProps())
